/**
 * Unauthenticated route definitions
 * Routes that don't require authentication (e.g., login page)
 */
import { RouteDefinition } from "./types";

/**
 * Routes accessible without authentication
 */
const unauthenticatedRoutes: RouteDefinition[] = [
  {
    name: "login",
    path: "/login?next",
  },
];

export default unauthenticatedRoutes;
